export const DiscoverConst = {
	tileWidth: 304,
	tileGap: 24,
	extraGap: 28,
	marginMobile: 16,
	marginMedium: 40,
	marginDesktop: 80,
	marginOverlay: 50,
	marginLiveTv: 36,
	liveTileTop: 40,
	mobileBreak: 540,
	mediumBreak: 1024,
	laneLiveTileBreak: 776,
	useLivePlayer: true
}
